import { ReactElement, useState } from 'react'
import styled from 'styled-components'
import { defaultTheme } from '../../../../../theme'
import { Thumbnail } from '../../../../../ui-components/products/Thumbnail'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { I18n } from '../../../../../i18n'
import { GroupPart } from '../../../../../store/lists/interfaces'

interface Props {
  category: string
  list: string
  group: string
  parts: GroupPart[]
}

const CollapsibleGroup = (props: Props): ReactElement => {
  const { category, list, group, parts } = props

  const [open, setOpen] = useState(true)

  return (
    <Container>
      <Breadcrumb>
        {open ? (
          <ExpandLess
            style={{ cursor: 'pointer' }}
            onClick={() => setOpen(!open)}
          />
        ) : (
          <ExpandMore
            style={{ cursor: 'pointer' }}
            onClick={() => setOpen(!open)}
          />
        )}

        <BreadcrumbText>
          {category}
          {'\u00a0'}
        </BreadcrumbText>
        <Divider>|</Divider>
        <BreadcrumbText>
          {'\u00a0'}
          {list}
          {'\u00a0'}
        </BreadcrumbText>
        <Divider>|</Divider>
        <BreadcrumbText>{group}</BreadcrumbText>
        <ItemsAmountSubtitle>({parts?.length} items)</ItemsAmountSubtitle>
      </Breadcrumb>

      {open && (
        <Container>
          <HeaderRow>
            <ColHeader width="16.6%">
              <I18n name="brand" />
            </ColHeader>
            <ColHeader width="16.6%">
              <I18n name="MFR" />
            </ColHeader>
            <ColHeader width="16.6%">
              <I18n name="PART #" />
            </ColHeader>
            <ColHeader width="16.6%">
              <I18n name="QTY" />
            </ColHeader>
            <ColHeader width="16.6%">
              <I18n name="description" />
            </ColHeader>
            <ColHeader width="16.6%">
              <I18n name="COMMENTS" />
            </ColHeader>
          </HeaderRow>
          {parts?.map((item, index) => (
            <InputWrapper key={index}>
              <TextInputWrapper width="16.6%">
                <Thumbnail urlOrBase64="" width={90} height={90} placeholder />
              </TextInputWrapper>
              <TextInputWrapper width="16.6%">
                <p>{item?.lineCode}</p>
              </TextInputWrapper>
              <TextInputWrapper width="16.6%">
                <p>{item?.partNumber}</p>
              </TextInputWrapper>
              <TextInputWrapper width="16.6%">
                <QuantityContent>{item?.stockQty}</QuantityContent>
              </TextInputWrapper>
              <TextInputWrapper width="16.6%">
                <p>{item?.description}</p>
              </TextInputWrapper>
              <TextInputWrapper width="16.6%">
                <p>{item?.comment}</p>
              </TextInputWrapper>
            </InputWrapper>
          ))}
        </Container>
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
`

const BreadcrumbText = styled.span`
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${defaultTheme.colors.primaryText};
  margin: 0px 8px 0px 8px;
`

interface TextInputWrapperProps {
  width: string
}

const TextInputWrapper = styled.div<TextInputWrapperProps>`
  padding: 16px 16px 16px 0px;
  width: ${(p) => p.width};
  display: flex;
  word-break: break-word;
`

const InputWrapper = styled.div`
  display: flex;
  width: 100%;
  height: fit-content;
  padding: 8px 32px;
  border-bottom: 1px solid ${defaultTheme.colors.borderTable};
`

const QuantityContent = styled.p`
  text-align: right;
  width: 27px;
`

const Divider = styled.span`
  color: ${defaultTheme.colors.borderTable};
`

const HeaderRow = styled.div`
  background: ${defaultTheme.colors.rowFeaturedBackground};
  box-shadow:
    inset 0px -1px 0px ${defaultTheme.colors.borderTable},
    inset 0px 1px 0px ${defaultTheme.colors.borderTable};

  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 16px;
  padding: 8px 32px;
`

interface HeaderRowProps {
  width?: string
}
const ColHeader = styled.div<HeaderRowProps>`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  /* identical to box height, or 171% */
  display: flex;
  align-items: center;
  text-transform: uppercase;
  width: ${(p) => p.width};
  color: ${defaultTheme.colors.columnBorder};
  padding-right: 24px;
`

const ItemsAmountSubtitle = styled.span`
  font-family: 'Oswald';
  font-weight: 450;
  font-size: 16px;
  color: ${defaultTheme.colors.greyLight};
`

export default CollapsibleGroup
